module.exports = {
    title: "Library",
    crud: {
        create: "Create Library",
        edit: "Edit Library",
    },
    table: {
        username: "Username",
        name: "Library",
        permission: "permission",
        numberOfUsers: 'Number Of Users',
    },
    form: {
        name: "Library",
        permission: "Permission",
    },
    validation: {
        required: {
            name: 'library is required',
        },
        common: {
            letter: 'letters.',
        }
    },
}
